/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { toast } from 'common/helpers/toastConfig';
import TextInput from 'components/form/textInput';
import CheckBox from 'components/form/checkbox';
import AppSwitch from 'components/form/switch';
import PanelBoxLayout from 'components/layout/panelBox';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import { useActions } from 'common/hooks/useActions';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router';
import { RejectReasonOwnerType } from 'common/enums';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const CreateNewTeaboyRejectReason = () => {
  const [status, setStatus] = useState(false);
  const [values, setValues] = useState<any>({
    needCustomText: false,
    translations: [
      {
        language: 'en',
        translate: ''
      },
      {
        language: 'ar',
        translate: ''
      }
    ],
    ownerType: RejectReasonOwnerType.teaboy,
    isActive: status
  });

  const { rejectReasonCreateRequestAction, rejectReasonGetOneRequestAction, rejectReasonUpdateRequestAction } =
    useActions();
  const { rejectReason }: any = useTypedSelector((state) => state.Cafeteria);

  const params: any = useParams();
  const navigate = useNavigate();

  const transformReasonTranslations = (reasonTranslations: any[]) => {
    const languages = ['en', 'ar'];

    return languages.map((language) => {
      const translation = reasonTranslations?.find((t) => t.language === language);
      return {
        language,
        translate: translation?.translate || ''
      };
    });
  };

  const submitHandler = (e: any, kind: string) => {
    e.preventDefault();

    const englishTitle = values?.translations?.find((t: any) => t.language === 'en')?.translate;
    if (!englishTitle) {
      toast({ model: 'error', message: 'Please enter an English title' });
      return;
    }

    const arabicTitle = values?.translations?.find((t: any) => t.language === 'ar')?.translate;
    if (!arabicTitle) {
      toast({ model: 'error', message: 'Please enter an Arabic title' });
      return;
    }

    if (kind === 'create') {
      const requestBody = {
        needCustomText: values.needCustomText,
        translations: transformReasonTranslations(values.translations),
        ownerType: values.ownerType,
        isActive: status
      };
      rejectReasonCreateRequestAction(requestBody, () => navigate('/panel/cafeteria/teaboy-cancelled-reason'));
      return;
    }

    if (kind === 'update') {
      const requestBody = {
        id: +params?.id,
        needCustomText: values.needCustomText,
        translations: values.translations,
        isActive: status
      };
      rejectReasonUpdateRequestAction(requestBody, () => navigate('/panel/cafeteria/teaboy-cancelled-reason'));
      return;
    }
  };

  useEffect(() => {
    if (params?.id) rejectReasonGetOneRequestAction(params?.id);
  }, [params?.id]);

  useEffect(() => {
    if (params?.id && rejectReason) {
      setValues({
        ...values,
        needCustomText: rejectReason?.data?.list?.needCustomText,
        ownerType: rejectReason?.data?.list?.ownerType,
        translations: rejectReason?.data?.list?.reasonTranslations
      });
      setStatus(rejectReason?.data?.list?.isActive);
    }
  }, [params, rejectReason]);

  return (
    <S.Container>
      <PageTitle title={params?.id ? 'Reason Details' : 'Create New Reason'} />

      <S.Form onSubmit={(e) => submitHandler(e, params?.id ? 'update' : 'create')}>
        {/*
         * Active moved into the section head, the way it did on Menu Details
         * and Create Customization. It was a bare antd Switch in the page
         * header with `backgroundColor` set inline to `#1DBAAF` or `#FF6464`
         * — the off state painted red, as though not being offered yet were a
         * fault — above 80px of empty space.
         */}
        <PanelBoxLayout
          title="Reason"
          info={<AppSwitch theme="two" checked={status} onChange={() => setStatus(!status)} text="Active" />}
        >
          <S.Rows>
            <S.FormBoxes>
              <TextInput
                label="Reason"
                langTag="EN"
                required
                name="en-title"
                value={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
                onChange={(e) => {
                  setValues({
                    ...values,
                    translations: values?.translations?.map((t: any) =>
                      t.language === 'en' ? { ...t, translate: e.target.value } : t
                    )
                  });
                }}
                placeholder="Out of stock"
              />

              <TextInput
                label="Reason"
                langTag="AR"
                required
                dir="rtl"
                name="ar-title"
                value={values?.translations?.find((t: any) => t.language === 'ar')?.translate || ''}
                onChange={(e) => {
                  setValues({
                    ...values,
                    translations: values?.translations?.map((t: any) =>
                      t.language === 'ar' ? { ...t, translate: e.target.value } : t
                    )
                  });
                }}
                placeholder="غير متوفر"
              />
            </S.FormBoxes>

            {/*
             * "Is Custom Text" named the field, not what ticking it does. It
             * is the design's checkbox row now, and it says what happens.
             */}
            <S.Check>
              <CheckBox
                checked={!!values.needCustomText}
                onChange={(checked: boolean) => setValues({ ...values, needCustomText: checked })}
                text="Ask for a written explanation as well"
              />
            </S.Check>
          </S.Rows>

          <S.Actions>
            <OutlineButton link="/panel/cafeteria/teaboy-cancelled-reason">Cancel</OutlineButton>
            <PrimaryButton type="submit">{params?.id ? 'Save reason' : 'Create reason'}</PrimaryButton>
          </S.Actions>
        </PanelBoxLayout>
      </S.Form>
    </S.Container>
  );
};

export default CreateNewTeaboyRejectReason;
